import GraphQL from "../../api/graphql";
import get from "lodash/get";
import { make } from "vuex-pathify";

const state = {
    id: null,
    selectedItems: [],
    usersList: [],
    usersOptions: [],
    selectedUsers: []
};

const mutations = make.mutations(state);

const actions = {
    async fetch({ rootState }, favoriteListId) {
        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        const response = await client.query({
            query: `
                query($favoriteListId: ID!) {
                    favoriteListById(id: $favoriteListId){
                        users {
                            id,
                            name,
                            email
                        }
                    }
                }
            `,
            variables: {
                favoriteListId
            }
        });

        const users = get(response, "data.favoriteListById.users");

        this.set("usersFavoriteLists/usersList", users);
    },
    reset() {
        this.set("usersFavoriteLists/selectedUsers", []);
    },
    async fetchUsersOptions({ rootState }) {
        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        const response = await client.query({
            query: `
               {
                    users {
                        id,
                        name,
                    }
               }
            `,
            variables: {}
        });

        this.set("usersFavoriteLists/usersOptions", response.data.users);
    },
    async shareFavoriteList({ dispatch, rootState }, params) {
        const favorite_list_id = params.favorite_list_id;
        const users_id = params.users_id;

        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        await client.query({
            query: `
                mutation($favoriteListId: ID!, $userIds: [ID!]) {
                    addUsersInFavoriteList(data: {id: $favoriteListId, users: $userIds}) {
                        id
                    }
                  }
            `,
            variables: {
                favoriteListId: favorite_list_id,
                userIds: users_id
            }
        });

        this.set("usersFavoriteLists/selectedUsers", []);

        await dispatch("fetch", favorite_list_id);
    },

    async removeUserFavoriteList({ dispatch, rootState }, params) {
        const user_id = params.user_id;
        const favorite_list_id = params.favorite_list_id;

        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        await client.query({
            query: `
                mutation($favoriteListId: ID!, $userId: ID!) {
                    removeUsersFromFavoriteList(data: {id: $favoriteListId, users: [$userId]}) {
                        id
                    }
                }
            `,
            variables: {
                favoriteListId: favorite_list_id,
                userId: user_id
            }
        });

        await dispatch("fetch", favorite_list_id);
    }
};

export default { state, mutations, actions };
